import { formatClassDaysTimesComma } from "@/lib/utils/classScheduleDisplay";
import { formatTimeTo12Hour } from "@/lib/utils/date/date";
import type { GetAvailableClassResponse } from "@/openapi/generated";

type MakeupClassScheduleSource = {
  classDays?: GetAvailableClassResponse["classDays"] | null;
  classStartTime?: string | null;
  classEndTime?: string | null;
};

function formatAvailableClassSchedule(
  cls: MakeupClassScheduleSource,
): string | null {
  const schedule = formatClassDaysTimesComma(cls.classDays);
  if (schedule && schedule !== "N/A") {
    return schedule;
  }

  const start = formatTimeTo12Hour(cls.classStartTime);
  const end = formatTimeTo12Hour(cls.classEndTime);
  if (start && end) {
    return `${start} – ${end}`;
  }
  return start || end || null;
}

export type MakeupClassOptionMeta = {
  location: string | null;
  schedule: string | null;
};

/** Location and recurring schedule for makeup class picker rows. */
export function getMakeupClassOptionMeta(
  cls: GetAvailableClassResponse,
): MakeupClassOptionMeta {
  return {
    location: cls.location?.name?.trim() || null,
    schedule: formatAvailableClassSchedule(cls),
  };
}

/** Dropdown and chip label so two classes with the same name stay distinct. */
export function formatMakeupFilterClassLabel(
  cls: MakeupClassScheduleSource & {
    name?: string | null;
    classId?: unknown;
  },
): string {
  const classId =
    typeof cls.classId === "string" || typeof cls.classId === "number"
      ? cls.classId
      : null;
  const name =
    cls.name?.trim() || (classId != null ? `Class #${classId}` : "Class");
  const schedule = formatAvailableClassSchedule(cls);
  return schedule ? `${name} · ${schedule}` : name;
}
